import {default as classNames} from "classnames";
import {ComponentPropsWithoutRef, ElementType, ForwardedRef, forwardRef} from "react";

import {InputComponent, InputProps} from "@/components/input/Input.types.ts";

import styles from "./Input.module.scss";

export const Input = forwardRef(
  <T extends ElementType = "input">(
    {className, as, children, size = "small", dataTestid, ...props}: InputProps<T>,
    ref: ForwardedRef<unknown>
  ) => {
    const Element = as || "input";
    return (
      <Element
        className={classNames(className, styles.input, styles[size], "form-control")}
        ref={ref}
        data-testid={dataTestid}
        {...(props as ComponentPropsWithoutRef<T>)}
      >
        {children}
      </Element>
    );
  }
) as InputComponent;
